const geneAnnotationDatabase: any = [{
  value: 'Anolis carolinensis',
  label: 'Anolis carolinensis',
  children: [
    {
      value: 'C1',
      label: 'C1',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C2',
      label: 'C2',
      children: [{
        value: 'CGP',
        label: 'CGP'
      }, {
        value: 'CP',
        label: 'CP'
      }, {
        value: 'CP:BIOCARTA',
        label: 'CP:BIOCARTA'
      }, {
        value: 'CP:KEGG',
        label: 'CP:KEGG'
      }, {
        value: 'CP:PID',
        label: 'CP:PID'
      }, {
        value: 'CP:REACTOME',
        label: 'CGP'
      }, {
        value: 'CP:WIKIPATHWAYS',
        label: 'CP:WIKIPATHWAYS'
      }]
    },
    {
      value: 'C3',
      label: 'C3',
      children: [{
        value: 'MIR:MIR_Legacy',
        label: 'MIR:MIR_Legacy'
      }, {
        value: 'MIR:MIRDB',
        label: 'MIR:MIRDB'
      }, {
        value: 'TFT:GTRD',
        label: 'TFT:GTRD'
      }, {
        value: 'TFT:TFT_Legacy',
        label: 'TFT:TFT_Legacy'
      }]
    },
    {
      value: 'C4',
      label: 'C4',
      children: [{
        value: 'CGN',
        label: 'CGN'
      }, {
        value: 'CM',
        label: 'CM'
      }]
    },
    {
      value: 'C5',
      label: 'C5',
      children: [{
        value: 'GO:BP',
        label: 'GO:BP'
      }, {
        value: 'GO:CC',
        label: 'GO:CC'
      }, {
        value: 'GO:MF',
        label: 'GO:MF'
      }, {
        value: 'HPO',
        label: 'HPO'
      }]
    },
    {
      value: 'C6',
      label: 'C6',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C7',
      label: 'C7',
      children: [{
        value: 'IMMUNESIGDB',
        label: 'IMMUNESIGDB'
      }, {
        value: 'VAX',
        label: 'VAX'
      }]
    },
    {
      value: 'C8',
      label: 'C8',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'H',
      label: 'H',
      children: [{
        value: 'None',
        label: 'None'
      }]
    }]
}, {
  value: 'Bos taurus',
  label: 'Bos taurus',
  children: [
    {
      value: 'C1',
      label: 'C1',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C2',
      label: 'C2',
      children: [{
        value: 'CGP',
        label: 'CGP'
      }, {
        value: 'CP',
        label: 'CP'
      }, {
        value: 'CP:BIOCARTA',
        label: 'CP:BIOCARTA'
      }, {
        value: 'CP:KEGG',
        label: 'CP:KEGG'
      }, {
        value: 'CP:PID',
        label: 'CP:PID'
      }, {
        value: 'CP:REACTOME',
        label: 'CGP'
      }, {
        value: 'CP:WIKIPATHWAYS',
        label: 'CP:WIKIPATHWAYS'
      }]
    },
    {
      value: 'C3',
      label: 'C3',
      children: [{
        value: 'MIR:MIR_Legacy',
        label: 'MIR:MIR_Legacy'
      }, {
        value: 'MIR:MIRDB',
        label: 'MIR:MIRDB'
      }, {
        value: 'TFT:GTRD',
        label: 'TFT:GTRD'
      }, {
        value: 'TFT:TFT_Legacy',
        label: 'TFT:TFT_Legacy'
      }]
    },
    {
      value: 'C4',
      label: 'C4',
      children: [{
        value: 'CGN',
        label: 'CGN'
      }, {
        value: 'CM',
        label: 'CM'
      }]
    },
    {
      value: 'C5',
      label: 'C5',
      children: [{
        value: 'GO:BP',
        label: 'GO:BP'
      }, {
        value: 'GO:CC',
        label: 'GO:CC'
      }, {
        value: 'GO:MF',
        label: 'GO:MF'
      }, {
        value: 'HPO',
        label: 'HPO'
      }]
    },
    {
      value: 'C6',
      label: 'C6',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C7',
      label: 'C7',
      children: [{
        value: 'IMMUNESIGDB',
        label: 'IMMUNESIGDB'
      }, {
        value: 'VAX',
        label: 'VAX'
      }]
    },
    {
      value: 'C8',
      label: 'C8',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'H',
      label: 'H',
      children: [{
        value: 'None',
        label: 'None'
      }]
    }]
}, {
  value: 'Caenorhabditis elegans',
  label: 'Caenorhabditis elegans',
  children: [
    {
      value: 'C1',
      label: 'C1',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C2',
      label: 'C2',
      children: [{
        value: 'CGP',
        label: 'CGP'
      }, {
        value: 'CP',
        label: 'CP'
      }, {
        value: 'CP:BIOCARTA',
        label: 'CP:BIOCARTA'
      }, {
        value: 'CP:KEGG',
        label: 'CP:KEGG'
      }, {
        value: 'CP:PID',
        label: 'CP:PID'
      }, {
        value: 'CP:REACTOME',
        label: 'CGP'
      }, {
        value: 'CP:WIKIPATHWAYS',
        label: 'CP:WIKIPATHWAYS'
      }]
    },
    {
      value: 'C3',
      label: 'C3',
      children: [{
        value: 'MIR:MIR_Legacy',
        label: 'MIR:MIR_Legacy'
      }, {
        value: 'MIR:MIRDB',
        label: 'MIR:MIRDB'
      }, {
        value: 'TFT:GTRD',
        label: 'TFT:GTRD'
      }, {
        value: 'TFT:TFT_Legacy',
        label: 'TFT:TFT_Legacy'
      }]
    },
    {
      value: 'C4',
      label: 'C4',
      children: [{
        value: 'CGN',
        label: 'CGN'
      }, {
        value: 'CM',
        label: 'CM'
      }]
    },
    {
      value: 'C5',
      label: 'C5',
      children: [{
        value: 'GO:BP',
        label: 'GO:BP'
      }, {
        value: 'GO:CC',
        label: 'GO:CC'
      }, {
        value: 'GO:MF',
        label: 'GO:MF'
      }, {
        value: 'HPO',
        label: 'HPO'
      }]
    },
    {
      value: 'C6',
      label: 'C6',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C7',
      label: 'C7',
      children: [{
        value: 'IMMUNESIGDB',
        label: 'IMMUNESIGDB'
      }, {
        value: 'VAX',
        label: 'VAX'
      }]
    },
    {
      value: 'C8',
      label: 'C8',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'H',
      label: 'H',
      children: [{
        value: 'None',
        label: 'None'
      }]
    }]
}, {
  value: 'Canis lupus familiaris',
  label: 'Canis lupus familiaris',
  children: [
    {
      value: 'C1',
      label: 'C1',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C2',
      label: 'C2',
      children: [{
        value: 'CGP',
        label: 'CGP'
      }, {
        value: 'CP',
        label: 'CP'
      }, {
        value: 'CP:BIOCARTA',
        label: 'CP:BIOCARTA'
      }, {
        value: 'CP:KEGG',
        label: 'CP:KEGG'
      }, {
        value: 'CP:PID',
        label: 'CP:PID'
      }, {
        value: 'CP:REACTOME',
        label: 'CGP'
      }, {
        value: 'CP:WIKIPATHWAYS',
        label: 'CP:WIKIPATHWAYS'
      }]
    },
    {
      value: 'C3',
      label: 'C3',
      children: [{
        value: 'MIR:MIR_Legacy',
        label: 'MIR:MIR_Legacy'
      }, {
        value: 'MIR:MIRDB',
        label: 'MIR:MIRDB'
      }, {
        value: 'TFT:GTRD',
        label: 'TFT:GTRD'
      }, {
        value: 'TFT:TFT_Legacy',
        label: 'TFT:TFT_Legacy'
      }]
    },
    {
      value: 'C4',
      label: 'C4',
      children: [{
        value: 'CGN',
        label: 'CGN'
      }, {
        value: 'CM',
        label: 'CM'
      }]
    },
    {
      value: 'C5',
      label: 'C5',
      children: [{
        value: 'GO:BP',
        label: 'GO:BP'
      }, {
        value: 'GO:CC',
        label: 'GO:CC'
      }, {
        value: 'GO:MF',
        label: 'GO:MF'
      }, {
        value: 'HPO',
        label: 'HPO'
      }]
    },
    {
      value: 'C6',
      label: 'C6',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C7',
      label: 'C7',
      children: [{
        value: 'IMMUNESIGDB',
        label: 'IMMUNESIGDB'
      }, {
        value: 'VAX',
        label: 'VAX'
      }]
    },
    {
      value: 'C8',
      label: 'C8',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'H',
      label: 'H',
      children: [{
        value: 'None',
        label: 'None'
      }]
    }]
}, {
  value: 'Danio rerio',
  label: 'Danio rerio',
  children: [
    {
      value: 'C1',
      label: 'C1',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C2',
      label: 'C2',
      children: [{
        value: 'CGP',
        label: 'CGP'
      }, {
        value: 'CP',
        label: 'CP'
      }, {
        value: 'CP:BIOCARTA',
        label: 'CP:BIOCARTA'
      }, {
        value: 'CP:KEGG',
        label: 'CP:KEGG'
      }, {
        value: 'CP:PID',
        label: 'CP:PID'
      }, {
        value: 'CP:REACTOME',
        label: 'CGP'
      }, {
        value: 'CP:WIKIPATHWAYS',
        label: 'CP:WIKIPATHWAYS'
      }]
    },
    {
      value: 'C3',
      label: 'C3',
      children: [{
        value: 'MIR:MIR_Legacy',
        label: 'MIR:MIR_Legacy'
      }, {
        value: 'MIR:MIRDB',
        label: 'MIR:MIRDB'
      }, {
        value: 'TFT:GTRD',
        label: 'TFT:GTRD'
      }, {
        value: 'TFT:TFT_Legacy',
        label: 'TFT:TFT_Legacy'
      }]
    },
    {
      value: 'C4',
      label: 'C4',
      children: [{
        value: 'CGN',
        label: 'CGN'
      }, {
        value: 'CM',
        label: 'CM'
      }]
    },
    {
      value: 'C5',
      label: 'C5',
      children: [{
        value: 'GO:BP',
        label: 'GO:BP'
      }, {
        value: 'GO:CC',
        label: 'GO:CC'
      }, {
        value: 'GO:MF',
        label: 'GO:MF'
      }, {
        value: 'HPO',
        label: 'HPO'
      }]
    },
    {
      value: 'C6',
      label: 'C6',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C7',
      label: 'C7',
      children: [{
        value: 'IMMUNESIGDB',
        label: 'IMMUNESIGDB'
      }, {
        value: 'VAX',
        label: 'VAX'
      }]
    },
    {
      value: 'C8',
      label: 'C8',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'H',
      label: 'H',
      children: [{
        value: 'None',
        label: 'None'
      }]
    }]
}, {
  value: 'Drosophila melanogaster',
  label: 'Drosophila melanogaster',
  children: [
    {
      value: 'C1',
      label: 'C1',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C2',
      label: 'C2',
      children: [{
        value: 'CGP',
        label: 'CGP'
      }, {
        value: 'CP',
        label: 'CP'
      }, {
        value: 'CP:BIOCARTA',
        label: 'CP:BIOCARTA'
      }, {
        value: 'CP:KEGG',
        label: 'CP:KEGG'
      }, {
        value: 'CP:PID',
        label: 'CP:PID'
      }, {
        value: 'CP:REACTOME',
        label: 'CGP'
      }, {
        value: 'CP:WIKIPATHWAYS',
        label: 'CP:WIKIPATHWAYS'
      }]
    },
    {
      value: 'C3',
      label: 'C3',
      children: [{
        value: 'MIR:MIR_Legacy',
        label: 'MIR:MIR_Legacy'
      }, {
        value: 'MIR:MIRDB',
        label: 'MIR:MIRDB'
      }, {
        value: 'TFT:GTRD',
        label: 'TFT:GTRD'
      }, {
        value: 'TFT:TFT_Legacy',
        label: 'TFT:TFT_Legacy'
      }]
    },
    {
      value: 'C4',
      label: 'C4',
      children: [{
        value: 'CGN',
        label: 'CGN'
      }, {
        value: 'CM',
        label: 'CM'
      }]
    },
    {
      value: 'C5',
      label: 'C5',
      children: [{
        value: 'GO:BP',
        label: 'GO:BP'
      }, {
        value: 'GO:CC',
        label: 'GO:CC'
      }, {
        value: 'GO:MF',
        label: 'GO:MF'
      }, {
        value: 'HPO',
        label: 'HPO'
      }]
    },
    {
      value: 'C6',
      label: 'C6',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C7',
      label: 'C7',
      children: [{
        value: 'IMMUNESIGDB',
        label: 'IMMUNESIGDB'
      }, {
        value: 'VAX',
        label: 'VAX'
      }]
    },
    {
      value: 'C8',
      label: 'C8',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'H',
      label: 'H',
      children: [{
        value: 'None',
        label: 'None'
      }]
    }]
}, {
  value: 'Equus caballus',
  label: 'Equus caballus',
  children: [
    {
      value: 'C1',
      label: 'C1',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C2',
      label: 'C2',
      children: [{
        value: 'CGP',
        label: 'CGP'
      }, {
        value: 'CP',
        label: 'CP'
      }, {
        value: 'CP:BIOCARTA',
        label: 'CP:BIOCARTA'
      }, {
        value: 'CP:KEGG',
        label: 'CP:KEGG'
      }, {
        value: 'CP:PID',
        label: 'CP:PID'
      }, {
        value: 'CP:REACTOME',
        label: 'CGP'
      }, {
        value: 'CP:WIKIPATHWAYS',
        label: 'CP:WIKIPATHWAYS'
      }]
    },
    {
      value: 'C3',
      label: 'C3',
      children: [{
        value: 'MIR:MIR_Legacy',
        label: 'MIR:MIR_Legacy'
      }, {
        value: 'MIR:MIRDB',
        label: 'MIR:MIRDB'
      }, {
        value: 'TFT:GTRD',
        label: 'TFT:GTRD'
      }, {
        value: 'TFT:TFT_Legacy',
        label: 'TFT:TFT_Legacy'
      }]
    },
    {
      value: 'C4',
      label: 'C4',
      children: [{
        value: 'CGN',
        label: 'CGN'
      }, {
        value: 'CM',
        label: 'CM'
      }]
    },
    {
      value: 'C5',
      label: 'C5',
      children: [{
        value: 'GO:BP',
        label: 'GO:BP'
      }, {
        value: 'GO:CC',
        label: 'GO:CC'
      }, {
        value: 'GO:MF',
        label: 'GO:MF'
      }, {
        value: 'HPO',
        label: 'HPO'
      }]
    },
    {
      value: 'C6',
      label: 'C6',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C7',
      label: 'C7',
      children: [{
        value: 'IMMUNESIGDB',
        label: 'IMMUNESIGDB'
      }, {
        value: 'VAX',
        label: 'VAX'
      }]
    },
    {
      value: 'C8',
      label: 'C8',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'H',
      label: 'H',
      children: [{
        value: 'None',
        label: 'None'
      }]
    }]
}, {
  value: 'Felis catus',
  label: 'Felis catus',
  children: [
    {
      value: 'C1',
      label: 'C1',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C2',
      label: 'C2',
      children: [{
        value: 'CGP',
        label: 'CGP'
      }, {
        value: 'CP',
        label: 'CP'
      }, {
        value: 'CP:BIOCARTA',
        label: 'CP:BIOCARTA'
      }, {
        value: 'CP:KEGG',
        label: 'CP:KEGG'
      }, {
        value: 'CP:PID',
        label: 'CP:PID'
      }, {
        value: 'CP:REACTOME',
        label: 'CGP'
      }, {
        value: 'CP:WIKIPATHWAYS',
        label: 'CP:WIKIPATHWAYS'
      }]
    },
    {
      value: 'C3',
      label: 'C3',
      children: [{
        value: 'MIR:MIR_Legacy',
        label: 'MIR:MIR_Legacy'
      }, {
        value: 'MIR:MIRDB',
        label: 'MIR:MIRDB'
      }, {
        value: 'TFT:GTRD',
        label: 'TFT:GTRD'
      }, {
        value: 'TFT:TFT_Legacy',
        label: 'TFT:TFT_Legacy'
      }]
    },
    {
      value: 'C4',
      label: 'C4',
      children: [{
        value: 'CGN',
        label: 'CGN'
      }, {
        value: 'CM',
        label: 'CM'
      }]
    },
    {
      value: 'C5',
      label: 'C5',
      children: [{
        value: 'GO:BP',
        label: 'GO:BP'
      }, {
        value: 'GO:CC',
        label: 'GO:CC'
      }, {
        value: 'GO:MF',
        label: 'GO:MF'
      }, {
        value: 'HPO',
        label: 'HPO'
      }]
    },
    {
      value: 'C6',
      label: 'C6',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C7',
      label: 'C7',
      children: [{
        value: 'IMMUNESIGDB',
        label: 'IMMUNESIGDB'
      }, {
        value: 'VAX',
        label: 'VAX'
      }]
    },
    {
      value: 'C8',
      label: 'C8',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'H',
      label: 'H',
      children: [{
        value: 'None',
        label: 'None'
      }]
    }]
}, {
  value: 'Gallus gallus',
  label: 'Gallus gallus',
  children: [
    {
      value: 'C1',
      label: 'C1',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C2',
      label: 'C2',
      children: [{
        value: 'CGP',
        label: 'CGP'
      }, {
        value: 'CP',
        label: 'CP'
      }, {
        value: 'CP:BIOCARTA',
        label: 'CP:BIOCARTA'
      }, {
        value: 'CP:KEGG',
        label: 'CP:KEGG'
      }, {
        value: 'CP:PID',
        label: 'CP:PID'
      }, {
        value: 'CP:REACTOME',
        label: 'CGP'
      }, {
        value: 'CP:WIKIPATHWAYS',
        label: 'CP:WIKIPATHWAYS'
      }]
    },
    {
      value: 'C3',
      label: 'C3',
      children: [{
        value: 'MIR:MIR_Legacy',
        label: 'MIR:MIR_Legacy'
      }, {
        value: 'MIR:MIRDB',
        label: 'MIR:MIRDB'
      }, {
        value: 'TFT:GTRD',
        label: 'TFT:GTRD'
      }, {
        value: 'TFT:TFT_Legacy',
        label: 'TFT:TFT_Legacy'
      }]
    },
    {
      value: 'C4',
      label: 'C4',
      children: [{
        value: 'CGN',
        label: 'CGN'
      }, {
        value: 'CM',
        label: 'CM'
      }]
    },
    {
      value: 'C5',
      label: 'C5',
      children: [{
        value: 'GO:BP',
        label: 'GO:BP'
      }, {
        value: 'GO:CC',
        label: 'GO:CC'
      }, {
        value: 'GO:MF',
        label: 'GO:MF'
      }, {
        value: 'HPO',
        label: 'HPO'
      }]
    },
    {
      value: 'C6',
      label: 'C6',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C7',
      label: 'C7',
      children: [{
        value: 'IMMUNESIGDB',
        label: 'IMMUNESIGDB'
      }, {
        value: 'VAX',
        label: 'VAX'
      }]
    },
    {
      value: 'C8',
      label: 'C8',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'H',
      label: 'H',
      children: [{
        value: 'None',
        label: 'None'
      }]
    }]
}, {
  value: 'Homo sapiens',
  label: 'Homo sapiens',
  children: [
    {
      value: 'C1',
      label: 'C1',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C2',
      label: 'C2',
      children: [{
        value: 'CGP',
        label: 'CGP'
      }, {
        value: 'CP',
        label: 'CP'
      }, {
        value: 'CP:BIOCARTA',
        label: 'CP:BIOCARTA'
      }, {
        value: 'CP:KEGG',
        label: 'CP:KEGG'
      }, {
        value: 'CP:PID',
        label: 'CP:PID'
      }, {
        value: 'CP:REACTOME',
        label: 'CGP'
      }, {
        value: 'CP:WIKIPATHWAYS',
        label: 'CP:WIKIPATHWAYS'
      }]
    },
    {
      value: 'C3',
      label: 'C3',
      children: [{
        value: 'MIR:MIR_Legacy',
        label: 'MIR:MIR_Legacy'
      }, {
        value: 'MIR:MIRDB',
        label: 'MIR:MIRDB'
      }, {
        value: 'TFT:GTRD',
        label: 'TFT:GTRD'
      }, {
        value: 'TFT:TFT_Legacy',
        label: 'TFT:TFT_Legacy'
      }]
    },
    {
      value: 'C4',
      label: 'C4',
      children: [{
        value: 'CGN',
        label: 'CGN'
      }, {
        value: 'CM',
        label: 'CM'
      }]
    },
    {
      value: 'C5',
      label: 'C5',
      children: [{
        value: 'GO:BP',
        label: 'GO:BP'
      }, {
        value: 'GO:CC',
        label: 'GO:CC'
      }, {
        value: 'GO:MF',
        label: 'GO:MF'
      }, {
        value: 'HPO',
        label: 'HPO'
      }]
    },
    {
      value: 'C6',
      label: 'C6',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C7',
      label: 'C7',
      children: [{
        value: 'IMMUNESIGDB',
        label: 'IMMUNESIGDB'
      }, {
        value: 'VAX',
        label: 'VAX'
      }]
    },
    {
      value: 'C8',
      label: 'C8',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'H',
      label: 'H',
      children: [{
        value: 'None',
        label: 'None'
      }]
    }]
}, {
  value: 'Macaca mulatta',
  label: 'Macaca mulatta',
  children: [
    {
      value: 'C1',
      label: 'C1',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C2',
      label: 'C2',
      children: [{
        value: 'CGP',
        label: 'CGP'
      }, {
        value: 'CP',
        label: 'CP'
      }, {
        value: 'CP:BIOCARTA',
        label: 'CP:BIOCARTA'
      }, {
        value: 'CP:KEGG',
        label: 'CP:KEGG'
      }, {
        value: 'CP:PID',
        label: 'CP:PID'
      }, {
        value: 'CP:REACTOME',
        label: 'CGP'
      }, {
        value: 'CP:WIKIPATHWAYS',
        label: 'CP:WIKIPATHWAYS'
      }]
    },
    {
      value: 'C3',
      label: 'C3',
      children: [{
        value: 'MIR:MIR_Legacy',
        label: 'MIR:MIR_Legacy'
      }, {
        value: 'MIR:MIRDB',
        label: 'MIR:MIRDB'
      }, {
        value: 'TFT:GTRD',
        label: 'TFT:GTRD'
      }, {
        value: 'TFT:TFT_Legacy',
        label: 'TFT:TFT_Legacy'
      }]
    },
    {
      value: 'C4',
      label: 'C4',
      children: [{
        value: 'CGN',
        label: 'CGN'
      }, {
        value: 'CM',
        label: 'CM'
      }]
    },
    {
      value: 'C5',
      label: 'C5',
      children: [{
        value: 'GO:BP',
        label: 'GO:BP'
      }, {
        value: 'GO:CC',
        label: 'GO:CC'
      }, {
        value: 'GO:MF',
        label: 'GO:MF'
      }, {
        value: 'HPO',
        label: 'HPO'
      }]
    },
    {
      value: 'C6',
      label: 'C6',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C7',
      label: 'C7',
      children: [{
        value: 'IMMUNESIGDB',
        label: 'IMMUNESIGDB'
      }, {
        value: 'VAX',
        label: 'VAX'
      }]
    },
    {
      value: 'C8',
      label: 'C8',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'H',
      label: 'H',
      children: [{
        value: 'None',
        label: 'None'
      }]
    }]
}, {
  value: 'Monodelphis domestica',
  label: 'Monodelphis domestica',
  children: [
    {
      value: 'C1',
      label: 'C1',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C2',
      label: 'C2',
      children: [{
        value: 'CGP',
        label: 'CGP'
      }, {
        value: 'CP',
        label: 'CP'
      }, {
        value: 'CP:BIOCARTA',
        label: 'CP:BIOCARTA'
      }, {
        value: 'CP:KEGG',
        label: 'CP:KEGG'
      }, {
        value: 'CP:PID',
        label: 'CP:PID'
      }, {
        value: 'CP:REACTOME',
        label: 'CGP'
      }, {
        value: 'CP:WIKIPATHWAYS',
        label: 'CP:WIKIPATHWAYS'
      }]
    },
    {
      value: 'C3',
      label: 'C3',
      children: [{
        value: 'MIR:MIR_Legacy',
        label: 'MIR:MIR_Legacy'
      }, {
        value: 'MIR:MIRDB',
        label: 'MIR:MIRDB'
      }, {
        value: 'TFT:GTRD',
        label: 'TFT:GTRD'
      }, {
        value: 'TFT:TFT_Legacy',
        label: 'TFT:TFT_Legacy'
      }]
    },
    {
      value: 'C4',
      label: 'C4',
      children: [{
        value: 'CGN',
        label: 'CGN'
      }, {
        value: 'CM',
        label: 'CM'
      }]
    },
    {
      value: 'C5',
      label: 'C5',
      children: [{
        value: 'GO:BP',
        label: 'GO:BP'
      }, {
        value: 'GO:CC',
        label: 'GO:CC'
      }, {
        value: 'GO:MF',
        label: 'GO:MF'
      }, {
        value: 'HPO',
        label: 'HPO'
      }]
    },
    {
      value: 'C6',
      label: 'C6',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C7',
      label: 'C7',
      children: [{
        value: 'IMMUNESIGDB',
        label: 'IMMUNESIGDB'
      }, {
        value: 'VAX',
        label: 'VAX'
      }]
    },
    {
      value: 'C8',
      label: 'C8',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'H',
      label: 'H',
      children: [{
        value: 'None',
        label: 'None'
      }]
    }]
}, {
  value: 'Mus musculus',
  label: 'Mus musculus',
  children: [
    {
      value: 'C1',
      label: 'C1',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C2',
      label: 'C2',
      children: [{
        value: 'CGP',
        label: 'CGP'
      }, {
        value: 'CP',
        label: 'CP'
      }, {
        value: 'CP:BIOCARTA',
        label: 'CP:BIOCARTA'
      }, {
        value: 'CP:KEGG',
        label: 'CP:KEGG'
      }, {
        value: 'CP:PID',
        label: 'CP:PID'
      }, {
        value: 'CP:REACTOME',
        label: 'CGP'
      }, {
        value: 'CP:WIKIPATHWAYS',
        label: 'CP:WIKIPATHWAYS'
      }]
    },
    {
      value: 'C3',
      label: 'C3',
      children: [{
        value: 'MIR:MIR_Legacy',
        label: 'MIR:MIR_Legacy'
      }, {
        value: 'MIR:MIRDB',
        label: 'MIR:MIRDB'
      }, {
        value: 'TFT:GTRD',
        label: 'TFT:GTRD'
      }, {
        value: 'TFT:TFT_Legacy',
        label: 'TFT:TFT_Legacy'
      }]
    },
    {
      value: 'C4',
      label: 'C4',
      children: [{
        value: 'CGN',
        label: 'CGN'
      }, {
        value: 'CM',
        label: 'CM'
      }]
    },
    {
      value: 'C5',
      label: 'C5',
      children: [{
        value: 'GO:BP',
        label: 'GO:BP'
      }, {
        value: 'GO:CC',
        label: 'GO:CC'
      }, {
        value: 'GO:MF',
        label: 'GO:MF'
      }, {
        value: 'HPO',
        label: 'HPO'
      }]
    },
    {
      value: 'C6',
      label: 'C6',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C7',
      label: 'C7',
      children: [{
        value: 'IMMUNESIGDB',
        label: 'IMMUNESIGDB'
      }, {
        value: 'VAX',
        label: 'VAX'
      }]
    },
    {
      value: 'C8',
      label: 'C8',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'H',
      label: 'H',
      children: [{
        value: 'None',
        label: 'None'
      }]
    }]
}, {
  value: 'Ornithorhynchus anatinus',
  label: 'Ornithorhynchus anatinus',
  children: [
    {
      value: 'C1',
      label: 'C1',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C2',
      label: 'C2',
      children: [{
        value: 'CGP',
        label: 'CGP'
      }, {
        value: 'CP',
        label: 'CP'
      }, {
        value: 'CP:BIOCARTA',
        label: 'CP:BIOCARTA'
      }, {
        value: 'CP:KEGG',
        label: 'CP:KEGG'
      }, {
        value: 'CP:PID',
        label: 'CP:PID'
      }, {
        value: 'CP:REACTOME',
        label: 'CGP'
      }, {
        value: 'CP:WIKIPATHWAYS',
        label: 'CP:WIKIPATHWAYS'
      }]
    },
    {
      value: 'C3',
      label: 'C3',
      children: [{
        value: 'MIR:MIR_Legacy',
        label: 'MIR:MIR_Legacy'
      }, {
        value: 'MIR:MIRDB',
        label: 'MIR:MIRDB'
      }, {
        value: 'TFT:GTRD',
        label: 'TFT:GTRD'
      }, {
        value: 'TFT:TFT_Legacy',
        label: 'TFT:TFT_Legacy'
      }]
    },
    {
      value: 'C4',
      label: 'C4',
      children: [{
        value: 'CGN',
        label: 'CGN'
      }, {
        value: 'CM',
        label: 'CM'
      }]
    },
    {
      value: 'C5',
      label: 'C5',
      children: [{
        value: 'GO:BP',
        label: 'GO:BP'
      }, {
        value: 'GO:CC',
        label: 'GO:CC'
      }, {
        value: 'GO:MF',
        label: 'GO:MF'
      }, {
        value: 'HPO',
        label: 'HPO'
      }]
    },
    {
      value: 'C6',
      label: 'C6',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C7',
      label: 'C7',
      children: [{
        value: 'IMMUNESIGDB',
        label: 'IMMUNESIGDB'
      }, {
        value: 'VAX',
        label: 'VAX'
      }]
    },
    {
      value: 'C8',
      label: 'C8',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'H',
      label: 'H',
      children: [{
        value: 'None',
        label: 'None'
      }]
    }]
}, {
  value: 'Pan troglodytes',
  label: 'Pan troglodytes',
  children: [
    {
      value: 'C1',
      label: 'C1',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C2',
      label: 'C2',
      children: [{
        value: 'CGP',
        label: 'CGP'
      }, {
        value: 'CP',
        label: 'CP'
      }, {
        value: 'CP:BIOCARTA',
        label: 'CP:BIOCARTA'
      }, {
        value: 'CP:KEGG',
        label: 'CP:KEGG'
      }, {
        value: 'CP:PID',
        label: 'CP:PID'
      }, {
        value: 'CP:REACTOME',
        label: 'CGP'
      }, {
        value: 'CP:WIKIPATHWAYS',
        label: 'CP:WIKIPATHWAYS'
      }]
    },
    {
      value: 'C3',
      label: 'C3',
      children: [{
        value: 'MIR:MIR_Legacy',
        label: 'MIR:MIR_Legacy'
      }, {
        value: 'MIR:MIRDB',
        label: 'MIR:MIRDB'
      }, {
        value: 'TFT:GTRD',
        label: 'TFT:GTRD'
      }, {
        value: 'TFT:TFT_Legacy',
        label: 'TFT:TFT_Legacy'
      }]
    },
    {
      value: 'C4',
      label: 'C4',
      children: [{
        value: 'CGN',
        label: 'CGN'
      }, {
        value: 'CM',
        label: 'CM'
      }]
    },
    {
      value: 'C5',
      label: 'C5',
      children: [{
        value: 'GO:BP',
        label: 'GO:BP'
      }, {
        value: 'GO:CC',
        label: 'GO:CC'
      }, {
        value: 'GO:MF',
        label: 'GO:MF'
      }, {
        value: 'HPO',
        label: 'HPO'
      }]
    },
    {
      value: 'C6',
      label: 'C6',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C7',
      label: 'C7',
      children: [{
        value: 'IMMUNESIGDB',
        label: 'IMMUNESIGDB'
      }, {
        value: 'VAX',
        label: 'VAX'
      }]
    },
    {
      value: 'C8',
      label: 'C8',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'H',
      label: 'H',
      children: [{
        value: 'None',
        label: 'None'
      }]
    }]
}, {
  value: 'Rattus norvegicus',
  label: 'Rattus norvegicus',
  children: [
    {
      value: 'C1',
      label: 'C1',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C2',
      label: 'C2',
      children: [{
        value: 'CGP',
        label: 'CGP'
      }, {
        value: 'CP',
        label: 'CP'
      }, {
        value: 'CP:BIOCARTA',
        label: 'CP:BIOCARTA'
      }, {
        value: 'CP:KEGG',
        label: 'CP:KEGG'
      }, {
        value: 'CP:PID',
        label: 'CP:PID'
      }, {
        value: 'CP:REACTOME',
        label: 'CGP'
      }, {
        value: 'CP:WIKIPATHWAYS',
        label: 'CP:WIKIPATHWAYS'
      }]
    },
    {
      value: 'C3',
      label: 'C3',
      children: [{
        value: 'MIR:MIR_Legacy',
        label: 'MIR:MIR_Legacy'
      }, {
        value: 'MIR:MIRDB',
        label: 'MIR:MIRDB'
      }, {
        value: 'TFT:GTRD',
        label: 'TFT:GTRD'
      }, {
        value: 'TFT:TFT_Legacy',
        label: 'TFT:TFT_Legacy'
      }]
    },
    {
      value: 'C4',
      label: 'C4',
      children: [{
        value: 'CGN',
        label: 'CGN'
      }, {
        value: 'CM',
        label: 'CM'
      }]
    },
    {
      value: 'C5',
      label: 'C5',
      children: [{
        value: 'GO:BP',
        label: 'GO:BP'
      }, {
        value: 'GO:CC',
        label: 'GO:CC'
      }, {
        value: 'GO:MF',
        label: 'GO:MF'
      }, {
        value: 'HPO',
        label: 'HPO'
      }]
    },
    {
      value: 'C6',
      label: 'C6',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C7',
      label: 'C7',
      children: [{
        value: 'IMMUNESIGDB',
        label: 'IMMUNESIGDB'
      }, {
        value: 'VAX',
        label: 'VAX'
      }]
    },
    {
      value: 'C8',
      label: 'C8',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'H',
      label: 'H',
      children: [{
        value: 'None',
        label: 'None'
      }]
    }]
}, {
  value: 'Saccharomyces cerevisiae',
  label: 'Saccharomyces cerevisiae',
  children: [
    {
      value: 'C1',
      label: 'C1',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C2',
      label: 'C2',
      children: [{
        value: 'CGP',
        label: 'CGP'
      }, {
        value: 'CP',
        label: 'CP'
      }, {
        value: 'CP:BIOCARTA',
        label: 'CP:BIOCARTA'
      }, {
        value: 'CP:KEGG',
        label: 'CP:KEGG'
      }, {
        value: 'CP:PID',
        label: 'CP:PID'
      }, {
        value: 'CP:REACTOME',
        label: 'CGP'
      }, {
        value: 'CP:WIKIPATHWAYS',
        label: 'CP:WIKIPATHWAYS'
      }]
    },
    {
      value: 'C3',
      label: 'C3',
      children: [{
        value: 'MIR:MIR_Legacy',
        label: 'MIR:MIR_Legacy'
      }, {
        value: 'MIR:MIRDB',
        label: 'MIR:MIRDB'
      }, {
        value: 'TFT:GTRD',
        label: 'TFT:GTRD'
      }, {
        value: 'TFT:TFT_Legacy',
        label: 'TFT:TFT_Legacy'
      }]
    },
    {
      value: 'C4',
      label: 'C4',
      children: [{
        value: 'CGN',
        label: 'CGN'
      }, {
        value: 'CM',
        label: 'CM'
      }]
    },
    {
      value: 'C5',
      label: 'C5',
      children: [{
        value: 'GO:BP',
        label: 'GO:BP'
      }, {
        value: 'GO:CC',
        label: 'GO:CC'
      }, {
        value: 'GO:MF',
        label: 'GO:MF'
      }, {
        value: 'HPO',
        label: 'HPO'
      }]
    },
    {
      value: 'C6',
      label: 'C6',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C7',
      label: 'C7',
      children: [{
        value: 'IMMUNESIGDB',
        label: 'IMMUNESIGDB'
      }, {
        value: 'VAX',
        label: 'VAX'
      }]
    },
    {
      value: 'C8',
      label: 'C8',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'H',
      label: 'H',
      children: [{
        value: 'None',
        label: 'None'
      }]
    }]
}, {
  value: 'Schizosaccharomyces pombe 972h-',
  label: 'Schizosaccharomyces pombe 972h-',
  children: [
    {
      value: 'C1',
      label: 'C1',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C2',
      label: 'C2',
      children: [{
        value: 'CGP',
        label: 'CGP'
      }, {
        value: 'CP',
        label: 'CP'
      }, {
        value: 'CP:BIOCARTA',
        label: 'CP:BIOCARTA'
      }, {
        value: 'CP:KEGG',
        label: 'CP:KEGG'
      }, {
        value: 'CP:PID',
        label: 'CP:PID'
      }, {
        value: 'CP:REACTOME',
        label: 'CGP'
      }, {
        value: 'CP:WIKIPATHWAYS',
        label: 'CP:WIKIPATHWAYS'
      }]
    },
    {
      value: 'C3',
      label: 'C3',
      children: [{
        value: 'MIR:MIR_Legacy',
        label: 'MIR:MIR_Legacy'
      }, {
        value: 'MIR:MIRDB',
        label: 'MIR:MIRDB'
      }, {
        value: 'TFT:GTRD',
        label: 'TFT:GTRD'
      }, {
        value: 'TFT:TFT_Legacy',
        label: 'TFT:TFT_Legacy'
      }]
    },
    {
      value: 'C4',
      label: 'C4',
      children: [{
        value: 'CGN',
        label: 'CGN'
      }, {
        value: 'CM',
        label: 'CM'
      }]
    },
    {
      value: 'C5',
      label: 'C5',
      children: [{
        value: 'GO:BP',
        label: 'GO:BP'
      }, {
        value: 'GO:CC',
        label: 'GO:CC'
      }, {
        value: 'GO:MF',
        label: 'GO:MF'
      }, {
        value: 'HPO',
        label: 'HPO'
      }]
    },
    {
      value: 'C6',
      label: 'C6',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C7',
      label: 'C7',
      children: [{
        value: 'IMMUNESIGDB',
        label: 'IMMUNESIGDB'
      }, {
        value: 'VAX',
        label: 'VAX'
      }]
    },
    {
      value: 'C8',
      label: 'C8',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'H',
      label: 'H',
      children: [{
        value: 'None',
        label: 'None'
      }]
    }]
}, {
  value: 'Sus scrofa',
  label: 'Sus scrofa',
  children: [
    {
      value: 'C1',
      label: 'C1',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C2',
      label: 'C2',
      children: [{
        value: 'CGP',
        label: 'CGP'
      }, {
        value: 'CP',
        label: 'CP'
      }, {
        value: 'CP:BIOCARTA',
        label: 'CP:BIOCARTA'
      }, {
        value: 'CP:KEGG',
        label: 'CP:KEGG'
      }, {
        value: 'CP:PID',
        label: 'CP:PID'
      }, {
        value: 'CP:REACTOME',
        label: 'CGP'
      }, {
        value: 'CP:WIKIPATHWAYS',
        label: 'CP:WIKIPATHWAYS'
      }]
    },
    {
      value: 'C3',
      label: 'C3',
      children: [{
        value: 'MIR:MIR_Legacy',
        label: 'MIR:MIR_Legacy'
      }, {
        value: 'MIR:MIRDB',
        label: 'MIR:MIRDB'
      }, {
        value: 'TFT:GTRD',
        label: 'TFT:GTRD'
      }, {
        value: 'TFT:TFT_Legacy',
        label: 'TFT:TFT_Legacy'
      }]
    },
    {
      value: 'C4',
      label: 'C4',
      children: [{
        value: 'CGN',
        label: 'CGN'
      }, {
        value: 'CM',
        label: 'CM'
      }]
    },
    {
      value: 'C5',
      label: 'C5',
      children: [{
        value: 'GO:BP',
        label: 'GO:BP'
      }, {
        value: 'GO:CC',
        label: 'GO:CC'
      }, {
        value: 'GO:MF',
        label: 'GO:MF'
      }, {
        value: 'HPO',
        label: 'HPO'
      }]
    },
    {
      value: 'C6',
      label: 'C6',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C7',
      label: 'C7',
      children: [{
        value: 'IMMUNESIGDB',
        label: 'IMMUNESIGDB'
      }, {
        value: 'VAX',
        label: 'VAX'
      }]
    },
    {
      value: 'C8',
      label: 'C8',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'H',
      label: 'H',
      children: [{
        value: 'None',
        label: 'None'
      }]
    }]
}, {
  value: 'Xenopus tropicalis',
  label: 'Xenopus tropicalis',
  children: [
    {
      value: 'C1',
      label: 'C1',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C2',
      label: 'C2',
      children: [{
        value: 'CGP',
        label: 'CGP'
      }, {
        value: 'CP',
        label: 'CP'
      }, {
        value: 'CP:BIOCARTA',
        label: 'CP:BIOCARTA'
      }, {
        value: 'CP:KEGG',
        label: 'CP:KEGG'
      }, {
        value: 'CP:PID',
        label: 'CP:PID'
      }, {
        value: 'CP:REACTOME',
        label: 'CGP'
      }, {
        value: 'CP:WIKIPATHWAYS',
        label: 'CP:WIKIPATHWAYS'
      }]
    },
    {
      value: 'C3',
      label: 'C3',
      children: [{
        value: 'MIR:MIR_Legacy',
        label: 'MIR:MIR_Legacy'
      }, {
        value: 'MIR:MIRDB',
        label: 'MIR:MIRDB'
      }, {
        value: 'TFT:GTRD',
        label: 'TFT:GTRD'
      }, {
        value: 'TFT:TFT_Legacy',
        label: 'TFT:TFT_Legacy'
      }]
    },
    {
      value: 'C4',
      label: 'C4',
      children: [{
        value: 'CGN',
        label: 'CGN'
      }, {
        value: 'CM',
        label: 'CM'
      }]
    },
    {
      value: 'C5',
      label: 'C5',
      children: [{
        value: 'GO:BP',
        label: 'GO:BP'
      }, {
        value: 'GO:CC',
        label: 'GO:CC'
      }, {
        value: 'GO:MF',
        label: 'GO:MF'
      }, {
        value: 'HPO',
        label: 'HPO'
      }]
    },
    {
      value: 'C6',
      label: 'C6',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'C7',
      label: 'C7',
      children: [{
        value: 'IMMUNESIGDB',
        label: 'IMMUNESIGDB'
      }, {
        value: 'VAX',
        label: 'VAX'
      }]
    },
    {
      value: 'C8',
      label: 'C8',
      children: [{
        value: 'None',
        label: 'None'
      }]
    },
    {
      value: 'H',
      label: 'H',
      children: [{
        value: 'None',
        label: 'None'
      }]
    }]
}]

export { geneAnnotationDatabase }
